import Btn from '@componentPrimitives/Btn';
import Divider from '@componentPrimitives/Divider';
import Flex from '@componentPrimitives/Flex';
import { useEntryIndex } from '@lib/features/entryIndexes';
import getEventIndexPerformances from '@lib/features/entryIndexes/getEventIndexPerformances';
import { fmtDateRange } from '@lib/utils/format';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { DateRange, DateRangeCalendar } from '@mui/x-date-pickers-pro';
import { Dayjs } from 'dayjs';
import { keys } from 'lodash';
import React, { useEffect } from 'react';
import { selectDateQuery, useDateRanges, useEventIndexDateQuery } from './useEventDateQuery';

export const EventIndexCalendarChip = () => {
  const ranges = useDateRanges();
  const { rangeKey, setRangeKey, rangeValue, setRangeValue } = useEventIndexDateQuery();

  const handleClear = () => {
    setRangeKey(null);
    setRangeValue([null, null]);
  };

  const [start, end] = rangeValue;

  const show = !!start && !!end;
  const formatted = fmtDateRange(start?.toISOString(), end?.toISOString());
  const label = rangeKey in ranges ? ranges[rangeKey].label : formatted;

  return show ? (
    <Btn size="small" startIcon="calendar" endIcon="close" onClick={handleClear}>
      {label}
    </Btn>
  ) : null;
};

export const EventIndexCalendarFilter = () => {
  const trigger = useEntryIndex((s) => s.trigger);
  const setCustomFetch = useEntryIndex((s) => s.setCustomFetch);
  const removeCustomFetch = useEntryIndex((s) => s.removeCustomFetch);

  React.useEffect(() => {
    setCustomFetch(getEventIndexPerformances);
    return removeCustomFetch;
  }, [removeCustomFetch, setCustomFetch]);

  const dateRanges = useDateRanges();
  const { rangeKey, setRangeKey, rangeValue, setRangeValue } = useEventIndexDateQuery();
  const { dateQuery } = useEventIndexDateQuery(selectDateQuery);

  const handleOptionChange = (_ev: React.SyntheticEvent<Element, Event>, val: string) => {
    if (!(val in dateRanges)) return;
    const range = dateRanges[val].value;
    setRangeKey(val);
    range && setRangeValue(range);
  };

  const handleCalendarRangeChange = (value: DateRange<Dayjs>) => {
    setRangeValue(value);
    setRangeKey('custom');
  };

  useEffect(() => {
    trigger({ page: 1 }, dateQuery);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateQuery]);

  return (
    <Flex>
      <FormControl>
        <RadioGroup
          {...{
            value: rangeKey,
            name: 'range',
            onChange: handleOptionChange,
            sx: { mb: 1 },
          }}>
          {keys(dateRanges).map((k) => (
            <FormControlLabel key={k} value={k} control={<Radio />} label={dateRanges[k].label} />
          ))}
          {/* <FormControlLabel value="custom" control={<Radio />} label={t('custom')} /> */}
        </RadioGroup>
      </FormControl>
      <Divider />
      {/* <input value={startDate ? startDate.toString() : undefined} /> */}
      {/* <input value={endDate ? endDate.toString() : undefined} /> */}

      {/* <DateCalendar showDaysOutsideCurrentMonth onChange={} > */}
      <DateRangeCalendar
        showDaysOutsideCurrentMonth
        onChange={handleCalendarRangeChange}
        value={rangeValue}
        calendars={1}
      />
    </Flex>
  );
};
